import { cn } from "@/lib/utils";

/** The first letters of up to two words: "Tima Topchiev" → "TT". */
export function initialsOf(label: string): string {
  return label
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => [...word][0] ?? "")
    .join("");
}

/**
 * A person: their photo when they put one up (2026-09-11), else their
 * initials in the display face. The photo is the stored 3:4 portrait as a
 * rounded tile, sized by `photoClassName` (a width); the initials are a
 * circle sized and coloured by `className`.
 */
export function Avatar({
  label,
  src,
  className,
  photoClassName,
  focus,
}: {
  label: string;
  src?: string | undefined;
  className?: string | undefined;
  photoClassName?: string | undefined;
  /** Where the tile reads the portrait, 0..1 down the frame; absent = the middle. */
  focus?: number | undefined;
}) {
  if (src !== undefined) {
    return (
      <img
        src={src}
        alt=""
        className={cn(
          "aspect-[3/4] shrink-0 rounded-2xl border object-cover",
          photoClassName ?? className,
        )}
        style={{ objectPosition: `center ${(focus ?? 0.5) * 100}%` }}
        draggable={false}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn("nxt flex shrink-0 items-center justify-center rounded-full border", className)}
    >
      {initialsOf(label)}
    </span>
  );
}
